import Session from "@lib/session";
import {
  ProfileAddDocument,
  ProfileAddMutationResult,
  ProfileAddMutationVariables,
} from "@graphql/api";

interface ProfileAddProps {
  email?: string | undefined;
  webId?: string | undefined;
  linkedReservations?: Array<string>;
  name?: string;
  options?: {
    noAutoLogin?: boolean;
  };
  password: string;
  telephone?: string;
  groupId?: number;
}

interface ProfileAddReturn {
  error?: string;
  profileId?: number;
}

export default async function profileAdd({
  email,
  webId,
  linkedReservations,
  name,
  options = {},
  password,
  telephone,
  groupId,
}: ProfileAddProps): Promise<ProfileAddReturn> {
  const client = global.window.apolloClient;
  
  const mutVars: ProfileAddMutationVariables = {
    email,
    webId,
    linkedReservations,
    name,
    password,
    telephone,
    groupId,
  };
  const result: ProfileAddMutationResult = await client.mutate({
    mutation: ProfileAddDocument,
    variables: mutVars,
  });

  const success = result?.data?.profileAdd?.success,
    profileId = result?.data?.profileAdd?.profileId,
    errorMessage = result?.data?.profileAdd?.errorMessage;

  if (success && profileId && !options?.noAutoLogin) {
    // Add new profile to session.
    const profiles = Session.getBooking().profiles;
    profiles.user = profileId;
    if (groupId) profiles.group = groupId; // Also set group in session
    Session.updateBooking({ profiles });
    await client.resetStore();
  }

  return { error: errorMessage || undefined, profileId: profileId || undefined };
}
